import React from "react";
import contact from "../images/contact.png";
import "./styles.css";
const Contact = () => {
  return (
    <div className="section">
      <div className="row">
        <div className="col-xs-3" style={{ borderRadius: "50px!important" }}>
          <img
            src={contact}
            alt="Contact"
            style={{ borderRadius: "50%!important" }}
          />
        </div>
        <div className="col-xs-9">
          <div className="ptitle"> Contact Details</div>

          <div className="pbody">
            
              Reach out to me at {""}
              <span className="pbottom">menidhikjha@gmail.com</span>
            
            <p>
              Connect with me on {""}
              <a
                className="pbottom"
                href="https://www.linkedin.com/in/nidhikjha/"
              >
                LinkedIn
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Contact;
